import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Card } from '../../ui';
import Steps from '../../Steps';
import { setStepsList } from '../../../actions';
import Loader from '../../Common/Loader';

import SaludForm_1 from './SaludForm_1';
import SaludForm_2 from './SaludForm_2';
import SaludForm_3 from './SaludForm_3';
import Cobertura from './Cobertura';
import Cotizacion from './Cotizacion';
import Purchase from './Purchase';

class Salud extends Component {
  constructor(props) {
    super(props);

    this.state = {
      globalSteps: ['1. Datos básicos', '2. Cobertura', '3. Cotización'],
      steps: [
        { pos: 0, global: 0, name: 'saludForm_1', backButton: false },
        { pos: 1, global: 0, name: 'saludForm_2', backButton: true },
        { pos: 2, global: 0, name: 'saludForm_3', backButton: true },
        { pos: 3, global: 1, name: 'cobertura', backButton: true },
        { pos: 4, global: 2, name: 'cotizacion', backButton: true },
        { pos: 5, global: 2, name: 'purchase', backButton: false }
      ]
    };
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    const { steps } = this.state;
    const { setStepsList } = this.props;
    setStepsList(steps);
  }

  getStepContent() {
    const { selectedStep } = this.props;

    switch (selectedStep.name) {
      case 'saludForm_1':
        return <SaludForm_1 />;
      case 'saludForm_2':
        return <SaludForm_2 />;
      case 'saludForm_3':
        return <SaludForm_3 />;
      case 'cobertura':
        return <Cobertura />;
      case 'cotizacion':
        return <Cotizacion />;
      case 'purchase':
        return <Purchase />;
      default:
        return null;
    }
  }

  render() {
    const { globalSteps } = this.state;
    const { loading } = this.props;

    return (
      <Card className="Card--medium">
        <div style={{ padding: '2rem 1rem 3rem 1rem' }}>
          <Steps globalSteps={globalSteps} />

          <div style={{ paddingTop: '3rem' }}>
            {loading ? <Loader /> : this.getStepContent()}
          </div>
        </div>
      </Card>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    loading: state.steps.isLoading,
    selectedStep: state.steps.selectedStep
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setStepsList: steps => {
      dispatch(setStepsList(steps));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Salud);
